import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function NotificationCenter() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        Notification Center
      </Typography>
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Notification Center Coming Soon
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This will include manual notification sending and platform announcements.
        </Typography>
      </Paper>
    </Box>
  );
}
